import { tv } from 'tailwind-variants'

export const messageListVariants = tv({
  slots: {
    container: 'flex flex-col w-full',
    listButton:
      'left-mili flex items-center justify-center bottom-centi gap-micro text-h5 text-primary-xlight mt-micro',
    buttonContainer: 'flex justify-center border-t items-center mt-deca',
    icon: 'flex text-kilo text-secondary-xlight'
  }
})
